<script>
import Accordion from '@/components/shared/Accordion.vue';

export default {
  name: 'AccordionList',
  components: { Accordion },
  props: {
    data: {
      type: Array
    }
  }
};
</script>

<template>
  <div class="content">
    <Accordion
      v-for="(item, index) in data"
      v-bind:key="item.title"
      :itemKey="index"
      :title="item.title"
      :content="item.content"
      :image="item.image"
      :order="item.order || 0"
    />
  </div>
</template>

<style scoped lang="scss">
div.content {
}
</style>
